import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSession } from "../../session/Context";
import { toast } from "react-toastify";
import React from "react";
import API from "../../Api";
import KeyCard from "../KeyCard";

export default function KeyManagement() {
  const navigate = useNavigate();
  const { brand } = useSession();
  const [keys, setKeys] = useState<any>({});
  const [showFormKeys, setShowFormKeys] = useState(false);
  const [keyData, setKeyData] = useState({
    name: "",
  });

  useEffect(() => {
    // Get current api keys

    let url = "/api/v1";
    if (brand !== "") {
      url += "/brand/" + brand + "/jwks?type=list";
    } else {
      url += "/brand/root/jwks?type=list";
    }

    API(url, {
      method: "GET",
    })
      .then((resp) => {
        //toast.success("Successfully added new issuance", { theme: "colored" });
        setKeys(resp);
      })
      .catch((e) => {
        toast.error("Error " + e, { theme: "colored" });
        console.error(e);
      });
  }, []);

  const changeKeyData = (e: any) => {
    const { name, value } = e.target;

    //Desctructing to get values
    setKeyData({
      ...keyData,
      [name]: value,
    });
  };

  const onSubmit = (event: React.FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
    let url = "/api/v1";
    if (brand !== "") {
      url += "/brand/" + brand + "/access-token";
    } else {
      url += "/brand/root/access-token";
    }

    API(url, {
      method: "POST",
      body: JSON.stringify({
        type: "new",
        name: keyData.name,
      }),
    })
      .then((resp) => {
        toast.success("Successfully added new api key " + keyData.name, {
          theme: "colored",
        });
        setShowFormKeys(false);
        setKeyData({ name: "" });
        let temp = resp.access_token;
        setKeys({ ...keys, [temp]: resp });
      })
      .catch((e) => {
        toast.error("Error " + e, { theme: "colored" });
        console.error(e);
        setShowFormKeys(false);
        setKeyData({ name: "" });
      });
  };

  const abbreviateString = (input: string, maxLength: number): string => {
    if (input.length <= maxLength) {
      return input;
    }
    const ellipsis = "...";
    const firstPartLength = Math.ceil((maxLength - ellipsis.length) / 2);
    const firstPart = input.slice(0, firstPartLength);
    const secondPart = input.slice(-firstPartLength);

    return `${firstPart}${ellipsis}${secondPart}`;
  };

  return (
    <div className="settings-section">
      <div className="messages">
        <h3>Signing keys</h3>
      </div>

      {showFormKeys ? (
        <>
          <form onSubmit={onSubmit} className="form">
            <div>
              <label>Name </label>
              <input
                required
                type="text"
                className="issuer-form"
                name="name"
                maxLength={240}
                value={keyData.name}
                onChange={changeKeyData}
              ></input>
            </div>

            <button
              className="btn btn-primary issuer-form"
              type="submit"
              value="Add"
            >
              Add signing key
            </button>
          </form>

          <button
            className="btn btn-secondary issuer-form"
            type="submit"
            value="Back"
            onClick={() => {
              setShowFormKeys(false);
              setKeyData({ name: "" });
            }}
          >
            Back
          </button>
        </>
      ) : (
        <>
          <button
            className="btn btn-primary"
            type="submit"
            value="Add"
            onClick={() => {
              setShowFormKeys(true);
            }}
            disabled
          >
            Add signing key
          </button>

          <div className="apikey_section">
            {Object.keys(keys).length === 0 ? (
              <>No signing keys yet.</>
            ) : (
              <>
                {Object.keys(keys).map((key: any) => {
                  const el = keys[key];
                  return (
                    <KeyCard
                      key={key}
                      data={el}
                      keyID={key}
                      updateData={(newData) => {
                        const newKeys = { ...keys };
                        newKeys[el.access_token] = newData;
                        setKeys(newKeys);
                      }}
                      deleteData={() => {
                        const newKeys = { ...keys };
                        delete newKeys[key.access_token];
                        setKeys(newKeys);
                      }}
                    />
                  );
                })}
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
}
